/* Copyright 2022- Martin Kufner */
Object.defineProperty(RegExp, "escape", {
    value(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
});